import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Package, FileText, KeyRound } from 'lucide-react';

const TABS = [
  { key: 'products', to: '/digital/products', label: 'Produk', icon: Package },
  { key: 'files', to: '/digital?tab=files', label: 'File', icon: FileText },
  { key: 'codes', to: '/digital?tab=codes', label: 'Kode Lisensi', icon: KeyRound },
];

export const DigitalTabs = ({ active }) => {
  const location = useLocation();
  const current = active || (location.pathname.startsWith('/digital/products') ? 'products' : 'files');

  return (
    <div className="flex gap-2 overflow-x-auto no-scrollbar" data-testid="digital-tabs">
      {TABS.map((tab) => {
        const Icon = tab.icon;
        const isActive = current === tab.key;
        return (
          <Link
            key={tab.key}
            to={tab.to}
            data-testid={`digital-tab-${tab.key}`}
            className={`shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${isActive
              ? 'bg-indigo-600 text-white'
              : 'bg-white dark:bg-zinc-900 text-slate-600 dark:text-zinc-300 border border-slate-200 dark:border-zinc-800 hover:border-slate-300 dark:hover:border-zinc-700'}`}
          >
            <Icon className="w-3.5 h-3.5" />
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
};

export default DigitalTabs;
